var map = {
	"./activities/basket.png": 5227,
	"./activities/basket_social.jpeg": 5410,
	"./activities/boxeo.png": 7770,
	"./activities/colonia.png": 2554,
	"./activities/funcional.jpg": 5786,
	"./activities/handball.png": 9637,
	"./activities/hiit.jpeg": 4204,
	"./activities/indoor_cycling.jpeg": 8519,
	"./activities/mamibasket.jpeg": 7224,
	"./activities/pilates.jpeg": 662,
	"./activities/sala.jpg": 6720,
	"./activities/volley.jpeg": 6911,
	"./activities/yoga.png": 733,
	"./banners/banner1 copy.png": 7217,
	"./banners/banner1.png": 3452,
	"./banners/banner2 copy.png": 1136,
	"./banners/banner2.png": 7735,
	"./banners/banner3 copy.png": 5559,
	"./banners/banner3.png": 4718,
	"./banners/banner4.png": 833,
	"./banners/directiva.jpeg": 1733,
	"./banners/historia1 copy.png": 4534,
	"./banners/historia1.png": 2289,
	"./banners/historia2 copy.png": 6979,
	"./banners/historia2.png": 3306,
	"./club/bg1 copy.jpg": 4797,
	"./club/bg1.jpg": 7020,
	"./club/bg2 copy.jpg": 2264,
	"./club/bg2.jpg": 1675,
	"./club/bg3 copy.png": 7411,
	"./club/bg3.png": 1402,
	"./club/bg4 copy.png": 7322,
	"./club/bg4.png": 8277,
	"./club/bg5.png": 5388,
	"./club/bg6.png": 3495,
	"./logo.png": 678,
	"./logo_hd.png": 5695,
	"./logo_hd_small.png": 4323,
	"./sponsors/barberia_black.png": 9099,
	"./sponsors/cindy_black.png": 724,
	"./sponsors/destinico_black.png": 7439,
	"./sponsors/dunk_party_black.png": 7582,
	"./sponsors/grupo3_black.png": 6297,
	"./sponsors/herreria_black.png": 7633,
	"./sponsors/kbza_black.png": 1735,
	"./sponsors/lave_ya_black.png": 4964,
	"./sponsors/oficina_sosa_black.png": 6771,
	"./sponsors/pascubake_black.png": 1364,
	"./sponsors/pastasroma_black.png": 5424,
	"./sponsors/proplast_black.png": 9920,
	"./sponsors/punto_sano_black.png": 6895,
	"./sponsors/supervero_black.png": 8332,
	"./sponsors/the_king_black.png": 8174,
	"./sponsors/tirapu_black.png": 8172,
	"./sponsors/wiki_black.png": 2787,
	"./sponsors/yinyin_black.png": 2911,
	"./staff/agostina.png": 4098,
	"./staff/agustin.png": 5097,
	"./staff/ale.jpeg": 1517,
	"./staff/alvin.png": 6438,
	"./staff/brian.jpeg": 5949,
	"./staff/camilo.jpeg": 4052,
	"./staff/facundo.jpeg": 1057,
	"./staff/julian.jpeg": 3930,
	"./staff/manza.jpeg": 5912,
	"./staff/nico.jpeg": 2672,
	"./staff/patricia.jpeg": 720
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;